import { Card, Divider, Empty, message, Skeleton, Tabs } from "antd";
import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { ChannelType } from "../../contexts/channels/ChannelProvider";
import {
  PaymentContext,
  PaymentContextProvider,
  PaymentContextType,
} from "../../contexts/payment/PaymentContext";
import { thousandSeparator } from "../../helpers/thousand_separator";
import { ChannelModel } from "../../models/ChannelModel";
import "./payment.css";
import axios from "axios";
import { CompanySingleResultInterface } from "../../models/CompanyModel";
import {
  ALFAMARTMidtrans,
  BANKOTHERVAMidtrans,
  BCAVAMidtrans,
  BNIVAMidtrans,
  BRIVAMidtrans,
  GOPAYMidtrans,
  MANDIRIVAMidtrans,
  PERTAMAVAMidtrans,
  SHOPEEMidtrans,
  QRISMidtrans,
} from "../../contexts/channels/interfaces/midtrans-channel";

function PaymentMidtransTopupV2() {
  return (
    <PaymentContextProvider>
      <PaymentTopupV2State />
    </PaymentContextProvider>
  );
}

function PaymentTopupV2State() {
  const [channel, setChannel] = React.useState<ChannelModel>();
  const [vaNumber, setVaNumber] = React.useState<string | undefined>(
    "Error fetching va number"
  );
  const [qrCode, setQrCode] = React.useState<string>();
  const [deeplink, setDeeplink] = React.useState<string>();
  const [bankCode, setBankCode] = React.useState<string>();
  const {
    walletDetail,
    getWalletDetail,
    getWalletDetailStatus,
    walletDetailStatus,
    doPaymentTopupV2,
    paymentResult,
    loading,
  } = useContext<PaymentContextType>(PaymentContext);
  const params = useParams();

  React.useEffect(() => {
    console.log(params);
    if (params) {
      if (params["invoice_code"] !== undefined) {
        getWalletDetail(params["invoice_code"] as string);

        const interval = setInterval(() => {
          getWalletDetailStatus(params["invoice_code"] as string);
        }, 5000);
        // Stop the interval when the component unmounts
        return () => clearInterval(interval);
      }
    }
  }, [params]);

  React.useEffect(() => {
    if (walletDetail !== undefined) {
      switch (walletDetail?.data?.payment_name?.toLowerCase()) {
        case "bca virtual account":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...BCAVAMidtrans,
          });
          break;
        case "mandiri virtual account":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...MANDIRIVAMidtrans,
          });
          break;
        case "bni virtual account":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...BNIVAMidtrans,
          });
          break;
        case "bri virtual account":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...BRIVAMidtrans,
          });
          break;
        case "permata virtual account":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...PERTAMAVAMidtrans,
          });
          break;
        case "bank lainnya":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...BANKOTHERVAMidtrans,
          });
          break;
        case "gopay":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...GOPAYMidtrans,
          });
          break;
        case "shopee":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...SHOPEEMidtrans,
          });
          break;
        case "alfamart":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...ALFAMARTMidtrans,
          });
          break;
        case "qris":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...QRISMidtrans,
          });
          break;
      }
    }
  }, [walletDetail]);

  React.useEffect(() => {
    if (walletDetailStatus !== undefined) {
      if (
        walletDetailStatus?.data?.status === "settlement" ||
        walletDetailStatus?.data?.status === "capture"
      ) {
        axios
          .get(
            `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
          )
          .then((res) => {
            const response = res.data as CompanySingleResultInterface;
            console.log(response);
            const url = `${response?.data?.platform_donation}/payment/success-topup?invoice_code=${walletDetailStatus?.data?.invoice_code}&result=success`;
            window.location.href = url;
          });
      } else if (
        walletDetailStatus?.data?.status === "cancel" ||
        walletDetailStatus?.data?.status === "deny"
      ) {
        axios
          .get(
            `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
          )
          .then((res) => {
            const response = res.data as CompanySingleResultInterface;
            const url = `${response?.data?.platform_donation}/payment/failed-topup?invoice_code=${walletDetailStatus?.data?.invoice_code}&result=failed`;
            window.location.href = url;
          });
      } else if (walletDetailStatus?.data?.status === "expire") {
        axios
          .get(
            `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
          )
          .then((res) => {
            const response = res.data as CompanySingleResultInterface;
            const url = `${response?.data?.platform_donation}/payment/timeout-topup?invoice_code=${walletDetailStatus?.data?.invoice_code}&result=expire`;
            window.location.href = url;
          });
      }
    }
  }, [walletDetailStatus]);

  React.useEffect(() => {
    if (channel) {
      // doPayment(channel, encrypt);
      // setVaNumber(channel.account_number);
      if (channel.type !== ChannelType.EWALLET) {
        if (channel.additional_text) {
          if (channel.additional_text.length > 0) {
            setBankCode(channel.additional_text[0]);
          }
        }
      }
    }
  }, [channel]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (walletDetail !== undefined && channel !== undefined) {
      console.log(walletDetail);
      doPaymentTopupV2(channel);
    }
  }, [walletDetail, channel]);

  React.useEffect(() => {
    if (paymentResult?.status) {
      if (
        paymentResult.data?.permata_va_number !== null &&
        paymentResult.data?.permata_va_number !== undefined
      ) {
        setVaNumber(paymentResult.data?.permata_va_number);
      } else if (paymentResult.data?.payment_type === "cstore") {
        setVaNumber(paymentResult.data.payment_code);
      } else if (paymentResult.data?.payment_type === "echannel") {
        setVaNumber(`${paymentResult.data?.bill_key}`);
        // setVaNumber(`${paymentResult.data?.biller_code}${paymentResult.data?.bill_key}`)
      } else {
        if (paymentResult.data?.va_numbers) {
          if (paymentResult.data?.va_numbers?.length > 0) {
            setVaNumber(paymentResult.data?.va_numbers![0].va_number);
          }
        }
      }

      if (paymentResult.data) {
        if (paymentResult.data.actions) {
          if (paymentResult.data.actions.length > 0) {
            var qr = paymentResult.data.actions.find(
              (item) => item.name === "generate-qr-code"
            );
            if (qr) {
              setQrCode(qr.url);
            }

            var dl = paymentResult.data.actions.find(
              (item) => item.name === "deeplink-redirect"
            );
            if (dl) {
              setDeeplink(dl.url);
            }
          }
        }
      }
    }
  }, [paymentResult]);

  return (
    <div
      style={{
        margin: 20,
      }}
    >
      <Skeleton loading={loading}>
        <h1>{channel?.title}</h1>
        <h2>{channel?.subtitle}</h2>
        {paymentResult?.status ? (
          <>
            <Card
              hoverable
              style={{
                marginBottom: 10,
              }}
            >
              <p className="amount">Jumlah</p>
              <div
                style={{
                  float: "right",
                }}
              >
                <span className="amount-rp">Rp </span>
                <span className="amount-number">
                  {thousandSeparator(walletDetail?.data?.amount)}
                </span>
              </div>
            </Card>
            {channel?.type === ChannelType.EWALLET && (
              <Card
                hoverable
                style={{
                  marginBottom: 10,
                  textAlign: "center",
                }}
              >
                <span className="account-number-text">
                  {channel.additional_text
                    ? channel.additional_text[0]
                    : "Error"}
                </span>
                <br />
                {qrCode !== undefined && (
                  <img
                    alt={qrCode}
                    src={qrCode}
                    style={{
                      textAlign: "center",
                      minWidth: "6.5cm",
                      maxWidth: "6.5cm",
                    }}
                  />
                )}
                <Divider />
                {deeplink !== undefined && (
                  <a
                    className="deeplink"
                    target={"_blank"}
                    rel="noreferrer"
                    href={deeplink}
                  >
                    {channel.additional_text
                      ? channel.additional_text[1]
                      : "Error"}
                  </a>
                )}
              </Card>
            )}
            {bankCode && (
              <Card
                hoverable
                style={{
                  marginBottom: 10,
                }}
              >
                <p className="amount">Kode Bank</p>
                <div
                  style={{
                    float: "right",
                  }}
                >
                  <span className="amount-number">{bankCode}</span>
                </div>
              </Card>
            )}
            {channel?.type !== ChannelType.EWALLET ? (
              <Card
                style={{
                  marginBottom: 10,
                }}
              >
                {vaNumber && (
                  <div style={{ float: "left" }}>
                    <span className="account-number-text-block">
                      Nomor Rekening
                    </span>
                    <span className="account-number">{vaNumber}</span>
                    <br />
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        message.info(`Nomor Rekening berhasil di salin.`);
                        navigator.clipboard.writeText(vaNumber);
                      }}
                    >
                      Salin Nomor Rekening
                    </a>
                  </div>
                )}
              </Card>
            ) : (
              <div></div>
            )}
          </>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={paymentResult?.data?.status_message}
          />
        )}
      </Skeleton>

      <Card hoverable title={"Detail Transaksi"} style={{ marginBottom: 10 }}>
        <span className="transaction-detail-text">Nama Transaksi</span>
        <span className="transaction-detail-description">Topup Wallet</span>
      </Card>

      {channel?.hows?.length > 0 ? (
        <Card hoverable title={"Cara Pembayaran"} style={{ marginBottom: 10 }}>
          <Tabs>
            {channel?.hows?.map((item, index) => (
              <Tabs.TabPane tab={item.name} key={index}>
                {item.steps?.map((item, index) => (
                  <p key={index}>
                    {index + 1}. {item}
                  </p>
                ))}
              </Tabs.TabPane>
            ))}
          </Tabs>
        </Card>
      ) : (
        <></>
      )}
    </div>
  );
}

export default PaymentMidtransTopupV2;
